"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginScreen = void 0;
var react_1 = __importStar(require("react"));
var LoginScreenBase_1 = require("./LoginScreenBase");
var contexts_1 = require("../../contexts");
var useErrorManager_1 = require("../../contexts/ErrorContext/useErrorManager");
var react_i18next_1 = require("react-i18next");
var EMAIL_REGEX = /^[A-Z0-9._%+'-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
/**
 * Component that renders a login screen that prompts a user to enter a username and password to login.
 *
 * @param usernameLabel label for the username field
 * @param usernameTextFieldProps props to pass to the username text field
 * @param usernameValidator function used to validate the username
 * @param initialUsernameValue username used to pre-populate the field
 * @param passwordLabel label for the password field
 * @param passwordTextFieldProps props to pass to the password text field
 * @param passwordValidator function used to validate the password
 * @param showRememberMe whether or not to show the 'remember me' checkbox
 * @param rememberMeLabel label for the 'remember me' checkbox
 * @param rememberMeInitialValue whether or not the 'remember me' checkbox should be checked by default
 * @param onRememberMeChanged callback function that is called when the 'remember me' checkbox is changed
 * @param loginButtonLabel label for the login button
 * @param onLogin callback function that is called when the login button is clicked
 * @param showForgotPassword whether or not to show the 'forgot password' link
 * @param forgotPasswordLabel label for the 'forgot password' link
 * @param onForgotPassword callback function that is called when the 'forgot password' link is clicked
 * @param showSelfRegistration whether or not to show the 'self registration' link
 * @param selfRegisterButtonLabel label for the 'self registration' link
 * @param selfRegisterInstructions instructions for the 'self registration' link
 * @param onSelfRegister callback function that is called when the 'self registration' link is clicked
 * @param showContactSupport whether or not to show the 'contact support' link
 * @param contactSupportLabel label for the 'contact support' link
 * @param onContactSupport callback function that is called when the 'contact support' link is clicked
 * @param errorDisplayConfig configuration for customizing how errors are displayed
 * @param showCyberSecurityBadge whether or not to show the cyber security badge
 * @param projectImage image to display at the top of the screen
 * @param header header to display at the top of the screen
 * @param footer footer to display at the bottom of the screen
 * @param WorkflowCardBaseProps props that will be passed to the WorkflowCard component
 *
 * @category Component
 */
var LoginScreen = function (props) {
    var t = (0, react_i18next_1.useTranslation)().t;
    var auth = (0, contexts_1.useAuthContext)();
    var actions = auth.actions, navigate = auth.navigate, routeConfig = auth.routeConfig, rememberMeDetails = auth.rememberMeDetails;
    var _a = (0, useErrorManager_1.useErrorManager)(), triggerError = _a.triggerError, errorManagerConfig = _a.errorManagerConfig;
    var _b = (0, react_1.useState)(false), isLoading = _b[0], setIsLoading = _b[1];
    var errorDisplayConfig = __assign(__assign(__assign({}, errorManagerConfig), props.errorDisplayConfig), { onClose: function () {
            if (props.errorDisplayConfig && props.errorDisplayConfig.onClose)
                props.errorDisplayConfig.onClose();
            if (errorManagerConfig.onClose)
                errorManagerConfig === null || errorManagerConfig === void 0 ? void 0 : errorManagerConfig.onClose();
        } });
    (0, react_1.useEffect)(function () {
        void actions.initiateSecurity();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var _c = props.usernameLabel, usernameLabel = _c === void 0 ? t('bluiCommon:LABELS.EMAIL') : _c, usernameTextFieldProps = props.usernameTextFieldProps, _d = props.usernameValidator, usernameValidator = _d === void 0 ? function (username) {
        if (!EMAIL_REGEX.test(username)) {
            return t('bluiCommon:MESSAGES.EMAIL_ENTRY_ERROR');
        }
        return true;
    } : _d, _e = props.initialUsernameValue, initialUsernameValue = _e === void 0 ? (rememberMeDetails === null || rememberMeDetails === void 0 ? void 0 : rememberMeDetails.email) || '' : _e, _f = props.passwordLabel, passwordLabel = _f === void 0 ? t('bluiCommon:LABELS.PASSWORD') : _f, passwordTextFieldProps = props.passwordTextFieldProps, _g = props.passwordValidator, passwordValidator = _g === void 0 ? function (password) {
        if (password.length < 1) {
            return t('bluiCommon:MESSAGES.PASSWORD_REQUIRED_ERROR');
        }
        return true;
    } : _g, _h = props.showRememberMe, showRememberMe = _h === void 0 ? true : _h, _j = props.rememberMeLabel, rememberMeLabel = _j === void 0 ? t('bluiCommon:ACTIONS.REMEMBER') : _j, _k = props.rememberMeInitialValue, rememberMeInitialValue = _k === void 0 ? (rememberMeDetails === null || rememberMeDetails === void 0 ? void 0 : rememberMeDetails.rememberMe) || false : _k, _l = props.onRememberMeChanged, onRememberMeChanged = _l === void 0 ? function (value) {
        var _a;
        (_a = props.onRememberMeChanged) === null || _a === void 0 ? void 0 : _a.call(props, value);
    } : _l, _m = props.loginButtonLabel, loginButtonLabel = _m === void 0 ? t('bluiCommon:ACTIONS.LOG_IN') : _m, _o = props.showForgotPassword, showForgotPassword = _o === void 0 ? true : _o, _p = props.forgotPasswordLabel, forgotPasswordLabel = _p === void 0 ? t('bluiCommon:LABELS.FORGOT_PASSWORD') : _p, _q = props.onForgotPassword, onForgotPassword = _q === void 0 ? function () { return navigate(routeConfig.FORGOT_PASSWORD); } : _q, _r = props.showSelfRegistration, showSelfRegistration = _r === void 0 ? true : _r, _s = props.selfRegisterInstructions, selfRegisterInstructions = _s === void 0 ? t('bluiCommon:LABELS.NEED_ACCOUNT') : _s, _t = props.selfRegisterButtonLabel, selfRegisterButtonLabel = _t === void 0 ? t('bluiCommon:ACTIONS.CREATE_ACCOUNT') : _t, _u = props.onSelfRegister, onSelfRegister = _u === void 0 ? function () { return navigate(routeConfig.REGISTER_SELF); } : _u, _v = props.showContactSupport, showContactSupport = _v === void 0 ? true : _v, _w = props.contactSupportLabel, contactSupportLabel = _w === void 0 ? t('bluiCommon:MESSAGES.CONTACT') : _w, _x = props.onContactSupport, onContactSupport = _x === void 0 ? function () { return navigate(routeConfig.SUPPORT); } : _x, _y = props.showCyberSecurityBadge, showCyberSecurityBadge = _y === void 0 ? true : _y, projectImage = props.projectImage, header = props.header, footer = props.footer;
    return (react_1.default.createElement(LoginScreenBase_1.LoginScreenBase, { loading: isLoading, usernameLabel: usernameLabel, usernameTextFieldProps: usernameTextFieldProps, usernameValidator: usernameValidator, initialUsernameValue: initialUsernameValue, passwordLabel: passwordLabel, passwordTextFieldProps: passwordTextFieldProps, passwordValidator: passwordValidator, showRememberMe: showRememberMe, rememberMeLabel: rememberMeLabel, rememberMeInitialValue: rememberMeInitialValue, onRememberMeChanged: onRememberMeChanged, loginButtonLabel: loginButtonLabel, onLogin: (function (username, password, rememberMe) { return __awaiter(void 0, void 0, void 0, function () {
            var _error_1;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 3, 4, 5]);
                        setIsLoading(true);
                        return [4 /*yield*/, actions.logIn(username, password, rememberMe)];
                    case 1:
                        _b.sent();
                        return [4 /*yield*/, ((_a = props.onLogin) === null || _a === void 0 ? void 0 : _a.call(props, username, password, rememberMe))];
                    case 2:
                        _b.sent();
                        return [3 /*break*/, 5];
                    case 3:
                        _error_1 = _b.sent();
                        triggerError(_error_1);
                        return [3 /*break*/, 5];
                    case 4:
                        setIsLoading(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); }), showForgotPassword: showForgotPassword, forgotPasswordLabel: forgotPasswordLabel, onForgotPassword: onForgotPassword, showSelfRegistration: showSelfRegistration, selfRegisterButtonLabel: selfRegisterButtonLabel, selfRegisterInstructions: selfRegisterInstructions, onSelfRegister: onSelfRegister, showContactSupport: showContactSupport, contactSupportLabel: contactSupportLabel, onContactSupport: onContactSupport, errorDisplayConfig: errorDisplayConfig, showCyberSecurityBadge: showCyberSecurityBadge, projectImage: projectImage, header: header, footer: footer }));
};
exports.LoginScreen = LoginScreen;
